export default {
  user(state) {
    return state.user;
  },
  loading(state) {
    return state.loading;
  },
  hasRoleGestorEntrega(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_ENTREGAS');
  },
  hasRoleGestorNotificacoes(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_NOTIFICACOES');
  },
  hasRoleCadastroProduto(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_CADASTRO_PRODUTO');
  },
  hasRoleComprador(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_COMPRADOR');
  },
  hasRoleGestorCompras(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_COMPRAS');
  },
  hasRoleAprovador(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_APROVADOR_COMPRAS');
  },
  hasRoleAprovadorRequisicao(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_APROVADOR_REQUISICAO');
  },
  hasRoleRequisicao(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_REQUISICAO');
  },
  hasModuleGestorFrete(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_FRETE');
  },
  hasRoleConfiguradorAlcadaCompra(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_CONFIGURADOR_ALCADA_COMPRA');
  },
  hasRoleConfiguradorAlcadaRequisicao(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_CONFIGURADOR_ALCADA_REQUISICAO');
  },
};
